import React from 'react';
import { Col } from '@gjensidige/core-grid';
import { Title, TitleProps } from '@gjensidige/builders-components';

import { IEnquiryHeaderProps } from '../../interfaces/EnquiryInterface';

export const EnquiryHeader: React.FC<IEnquiryHeaderProps> = (
  props: IEnquiryHeaderProps
) => {
  const renderHeader = () => {
    return (
      <div className="enquiry-header-wrapper pb-1">
          <Title as={"h4" as TitleProps['as']}>{props.questionHeader}</Title>
      </div>
    );
  };
  return (
    <>
      {props.questionHeader &&
        (props.wrapWithColumn ? (
          <Col md={12} sm={12} className="pt-md-8 pt-4 pb-2">
            {renderHeader()}
          </Col>
        ) : (
          renderHeader()
        ))}
    </>
  );
};
